import React, { useEffect, useRef, useState } from "react";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";

function Register(){
    const [saveRegisterData, setSaveRegisterData] = useState({
        firstname: "", lastname: "", mobilenumber: "", emailid: "", 
        shopnow: "", pincode: "", city: "", fulladdress: "", state: ""
    });
    const [showPopup, setShowPopup] = useState(false); // State to control the popup visibility

    const handlechangedata = (e) => {
        const value = e.target.value;
        const key = e.target.name;
        setSaveRegisterData({ ...saveRegisterData, [key]: value });
    };

    const submitregister = () => {
        // Clear previous red borders
        document.getElementById("firstname").style.border = "";
        document.getElementById("lastname").style.border = "";
        document.getElementById("mobilenumber").style.border = "";
        document.getElementById("emailid").style.border = "";
        document.getElementById("shopnow").style.border = "";
        document.getElementById("pincode").style.border = "";
        document.getElementById("state").style.border = "";
        document.getElementById("city").style.border = "";
        document.getElementById("fulladdress").style.border = "";

        // Form Validations
        if(saveRegisterData.firstname === ""){
            document.getElementById("firstname").style.border = "1px solid red";
            return false;
        }
        if(saveRegisterData.lastname === ""){
            document.getElementById("lastname").style.border = "1px solid red";
            return false;
        }
        if(saveRegisterData.mobilenumber === "" || saveRegisterData.mobilenumber.length !== 10 ){
            document.getElementById("mobilenumber").style.border = "1px solid red";
            return false;
        }
        if(saveRegisterData.emailid === ""){
            document.getElementById("emailid").style.border = "1px solid red";
            return false;
        }
        if(saveRegisterData.shopnow === ""){
            document.getElementById("shopnow").style.border = "1px solid red";
            return false;
        }
        if(saveRegisterData.pincode === ""){
            document.getElementById("pincode").style.border = "1px solid red";
            return false;
        }
        if(saveRegisterData.state === ""){
            document.getElementById("state").style.border = "1px solid red";
            return false;
        }
        if(saveRegisterData.city === ""){
            document.getElementById("city").style.border = "1px solid red";
            return false;
        }
        if(saveRegisterData.fulladdress === ""){
            document.getElementById("fulladdress").style.border = "1px solid red";
            return false;
        }

        // Trigger the success modal overlay statically
        setShowPopup(true);
    };

    const handleClosePopup = () => {
        setShowPopup(false);
        window.location.reload(); // Reload the page after they acknowledge the message
    };

    return(
        <>
        <div className="wrapper">
            <Header/>
            <section className="contact-layout1 pt-0 mt--100" style={{marginTop:"20px"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="contact-panel d-flex flex-wrap">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="contact-panel__title">Partner With Us</h4>
                                    </div>
                                    <div className="col-sm-6 col-md-6 col-lg-6">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="First Name" id="firstname" name="firstname" onChange={handlechangedata} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-md-6 col-lg-6">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Last Name" id="lastname" name="lastname" onChange={handlechangedata} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-md-6 col-lg-6">
                                        <div className="form-group">
                                            <input type="number" className="form-control" placeholder="Mobile Number" id="mobilenumber" name="mobilenumber" onChange={handlechangedata} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-md-6 col-lg-6">
                                        <div className="form-group">
                                            <input type="email" className="form-control" placeholder="Email ID" id="emailid" name="emailid" onChange={handlechangedata} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-md-6 col-lg-6">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Shop Name" id="shopnow" name="shopnow" onChange={handlechangedata} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-md-6 col-lg-6">
                                        <div className="form-group">
                                            <input type="number" className="form-control" placeholder="Pin Code" id="pincode" name="pincode" onChange={handlechangedata} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-md-6 col-lg-6">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="State" id="state" name="state" onChange={handlechangedata} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-md-6 col-lg-6">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="City" id="city" name="city" onChange={handlechangedata} />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-12 col-lg-12">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Full Address" id="fulladdress" name="fulladdress" onChange={handlechangedata} />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-12 col-lg-12">
                                        <button type="submit" onClick={submitregister} className="btn btn__secondary mt-10">
                                            <span>Submit Request</span> <i className="icon-arrow-right icon-outlined"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer/>
        </div>

        {/* --- Custom Popup Markup --- */}
        {showPopup && (
            <div style={styles.overlay}>
                <div style={styles.popup}>
                    <h3 style={styles.heading}>Success!</h3>
                    <p style={styles.message}>Your query is there now our team will contact you.</p>
                    <button onClick={handleClosePopup} style={styles.button}>Close</button>
                </div>
            </div>
        )}
        </>
    )
}

// In-line styles for the popup overlay
const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999
    },
    popup: {
        backgroundColor: '#fff',
        padding: '30px',
        borderRadius: '8px',
        boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
        textAlign: 'center',
        maxWidth: '400px',
        width: '90%'
    },
    heading: {
        margin: '0 0 10px 0',
        color: '#28a745'
    },
    message: {
        fontSize: '16px',
        color: '#333',
        marginBottom: '20px'
    },
    button: {
        backgroundColor: '#1f2d3d',
        color: '#fff',
        border: 'none',
        padding: '10px 25px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: 'bold'
    }
};

export default Register;